'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { useLanguage } from '@/lib/config/useLanguage';
import { useResolvedBranch } from '@/components/SiteHostProvider';
import StaticBreadcrumbWrapper from './StaticBreadcrumbWrapper';

interface StaticBreadcrumbClientProps {
  pageTitle?: string;
}

export default function StaticBreadcrumbClient({
  pageTitle,
}: StaticBreadcrumbClientProps) {
  const pathname = usePathname() || '/';
  const { code: branchCode } = useResolvedBranch();
  const { langCode } = useLanguage();

  return (
    <StaticBreadcrumbWrapper
      pathname={pathname}
      langCode={langCode}
      pageTitle={pageTitle}
      branchCode={branchCode}
    />
  );
}

